import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, user } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0d0d0c] px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="text-[#c9a86a] tracking-[0.3em] text-lg font-semibold">LE COLLECTIF HORLOGER</div>
          <div className="text-[11px] text-[#6f6a5f] mt-2 tracking-[0.2em]">ADMIN ACCESS · AN ATELIER DUGAS HOUSE</div>
        </div>
        <form
          onSubmit={submit}
          className="bg-[#16140f] border border-[#262420] rounded-xl p-8 shadow-2xl"
          data-testid="admin-login-form"
        >
          <div className="space-y-2 mb-4">
            <Label htmlFor="email" className="text-[#a8a294]">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email"
              className="bg-[#0d0d0c] border-[#33302a] text-[#e8e3d8]"
              placeholder="owner@lch.com"
            />
          </div>
          <div className="space-y-2 mb-6">
            <Label htmlFor="password" className="text-[#a8a294]">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password"
              className="bg-[#0d0d0c] border-[#33302a] text-[#e8e3d8]"
              placeholder="••••••••"
            />
          </div>
          <Button
            type="submit"
            disabled={busy}
            data-testid="login-submit"
            className="w-full bg-[#c9a86a] hover:bg-[#b89455] text-[#0d0d0c] font-semibold tracking-wide"
          >
            {busy ? "Signing in…" : "Enter"}
          </Button>
        </form>
        <p className="text-center text-[11px] text-[#4f4b43] mt-6">
          Authorized personnel only.
        </p>
      </div>
    </div>
  );
}
